const isEnabled = (key, featureFlags) => {
  // If feature flags don't exist within the object or the feature flag object is null
  // we are considering the flag disabled.
  if (!featureFlags || !Object.prototype.hasOwnProperty.call(featureFlags, key))
    return false

  return !!featureFlags[key]
}

/**
 * Generates a series of feature toggle functions that will instruct which features
 * are enabled or not
 * @param {Object} featureFlags Dictionary of feature flags
 */
export const createFeatureDecisions = (featureFlags) => {
  return {
    // #region Self Service
    selfService: {
      /**
       * Displays the booking status label on the original booking card.
       *
       * This feature flag is temporary and should be removed as soon as the Booking Card V2 design
       * has been approved for wide spread use.
       * @see [TASK 109](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/109) - Booking status label
       * @returns true: displays status label on v1 booking card. false: hides status label on v1 booking cards.
       */
      showBookingStatus: isEnabled(
        'r2B_SelfService_ShowBookingStatus',
        featureFlags
      ),
      /**
       * Displays the V2 booking cards.
       *
       * This feature flag is temporary and should be removed as soon as the Booking Card V2 design
       * has been approved for wide spread use.
       * @see [TASK 108](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/108) - Booking Card V2
       * @returns true: displays v2 booking card. false: displays v1 booking card
       */
      showBookingCardV2: isEnabled(
        'r2B_SelfService_ShowBookingCardV2',
        featureFlags
      ),
      /**
       * Enables the extend booking functionality
       *
       * @see [FEATURE 10](https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/10) - Extend booking
       * @returns true: displays extend booking CTA. false: hides extend booking CTA.
       */
      enableExtendBooking: isEnabled(
        'r2B_SelfService_EnableExtendBooking',
        featureFlags
      ),
    },
    // #endregion
  }
}
